// extracted by mini-css-extract-plugin
export default {"cls1":"PaperSelector-cls1__tT","cls2":"PaperSelector-cls2_YeE PaperSelector-cls1__tT"};